import React from "react";
import { useState, useEffect, useMemo } from "react";
import { DataGrid, getGridNumericOperators, getGridDateOperators  } from '@mui/x-data-grid';
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import { TextField } from '@mui/material';
import "./styles/Ventas.css";
import {  Link } from 'react-router-dom';
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { esES } from '@mui/x-data-grid/locales';
import CardResennas from "./component/CardResennas";
import {Dialog, DialogTitle, DialogContent, Button, DialogActions} from '@mui/material';
import Swal from 'sweetalert2';


const ProductoRenderer = ({ producto }) => {
    if (!producto || (!producto.Nombre && !producto.Descripcion && !producto.Tematica && !producto.ImagenPortada && !producto.FechaSubida)) {
        return (
            <div style={{ fontStyle: "italic", color: "#888" }}>
                Producto eliminado
            </div>
        );
    }

    return(
        <div style={{ display: "flex", alignItems: "center" }}>
            <img src={`data:image/png;base64,${producto.ImagenPortada}`} alt={producto.Nombre} style={{ width: "50px", height: "50px", marginRight: "10px" }} />
            <span>  {producto.Nombre}</span>
        </div>
    );
};

const PrecioRenderer = ({ producto }) => {
    return(
        <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
            <span style={{marginLeft: '15px'}}>{producto.Precio.toFixed(2)} €</span>
        </div>
    );
};

const ClienteRenderer = ({ cliente }) => {
    if (!cliente) {
        return (
            <div style={{ fontStyle: "italic", color: "#888", textAlign: "center" }}>
                Cliente eliminado
            </div>
        );
    }

    return(
        <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center'}}>
            <span> {cliente.Usuario} </span>    
        </div>
    );
};

const ValoracionRenderer = ({ resennas, onClick }) => {
    const resenna = resennas && resennas.length > 0 ? resennas[0] : null;
    
    if(!resenna) return <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>Sin valorar</div>;
    
    const rating = resenna.Valoracion;

    return (
        <div className="valoracion" style={{ cursor: 'pointer' }} onClick={onClick}>
            {Array.from({length: 5}, (_, index) =>{
                const entero = Math.floor(rating);
                const decimal = rating - entero
                if(index < entero) {
                    return <FaStar key={index} />;
                }
                else if (index === entero && decimal >= 0.5){
                    return <FaStarHalfAlt key={index} />;
                }
                else{
                    return <FaRegStar key={index} />;
                }
            })}
        </div>
    )
}

const DevolucionRenderer = ({cliente, producto}) => {
    const cantidadDevolver = Math.round(producto.Precio * 100);
    

    const handleDevolucion = async () => {
        const confirmarResultado = await Swal.fire({
            title: `¿Seguro que quieres devolver ${(cantidadDevolver / 100).toFixed(2)} € del producto "${producto.Nombre}" al usuario ${cliente.Usuario}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, devolver',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
        });        

        if (!confirmarResultado.isConfirmed) return;

        try{
            const respuesta = await fetch(`${baseUrl}/api/pago/refund`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    prod: producto._id,
                    cliente: cliente._id,
                    cantidadDevolver,
                }),
            })

            if (!respuesta.ok) {
                const error = await respuesta.json().catch(() => ({ error: 'Error al solicitar el reembolso' }))
                await Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: `No se pudo procesar la devolución:\n${error.error || JSON.stringify(error)}`,
                    confirmButtonText: 'Ok'
                });
                return;
            }

            const { refundId, status, amount} = await respuesta.json();
            await Swal.fire({
                icon: 'success',
                title: 'Devolución procesada',
                html: `· Importe devuelto: <strong>${(amount / 100).toFixed(2)} €</strong><br>al cliente <strong>${cliente.Usuario}</strong>`,
                confirmButtonText: 'OK'
            });
            window.location.reload();
        } catch(error){
            console.error(error);
            await Swal.fire({
                icon: 'error',
                title: 'Error inesperado',
                text: 'Ha ocurrido un error inesperado al procesar la devolución.',
                confirmButtonText: 'OK'
            });  
        }
    }
    return (
        <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
            <Link to="#">
                <button className="botonTabla" onClick={handleDevolucion} style={{ cursor: 'pointer' }}>
                    Gestionar devolución
                </button>
            </Link>
        </div>
    )
}

//Ordenación
const compararNombre = (v1, v2) => {
    const nombre1 = v1.toString();
    const nombre2 = v2.toString();
    return nombre1 > nombre2 ? 1 : nombre1 < nombre2 ? -1 : 0;
};

const compararCliente = (v1, v2) => {
    const nombre1 = v1.toString();
    const nombre2 = v2.toString();
    return nombre1 > nombre2 ? 1 : nombre1 < nombre2 ? -1 : 0;
};

const compararFecha = (v1, v2) => new Date(v1) - new Date(v2);

const compararValoracion = (v1, v2) => {
    const valor1 = v1 !== null ? parseFloat(v1) : 0
    const valor2 = v2 !== null ? parseFloat(v2) : 0
    return valor1 - valor2;
}

const compararPrecio = (v1, v2) => {
    const valor1 = parseFloat(v1);
    const valor2 = parseFloat(v2);
    return valor1 - valor2;
}

//Filtrado
//Filtrar Valoración
function ValorRatingIntroducido(props) {
    const { item, applyValue, focusElementRef } = props;

    const [rating, setRating] = useState(
        item.value !== null && item.value !== undefined ? Number(item.value) : null
    );
      
      
    const ratingRef = React.useRef(null);
    React.useImperativeHandle(focusElementRef, () => ({
        focus: () => {
            ratingRef.current
                .querySelector(`input[value="${Number(item.value) || ''}"]`)
                .focus();
      },
    }));

    const handleFilterChange = (event, newValue) => {
        let valorFinal;
        if(newValue === null) valorFinal = 0;
        else valorFinal = newValue;
        setRating(valorFinal);
        applyValue({ ...item, value: valorFinal });
    };
    
      return (
            <Box
            sx={{
                display: 'inline-flex',
                flexDirection: 'row',
                alignItems: 'center',
                height: 48,
                pl: '20px',
            }}
            >
          <Rating
            name="custom-rating-filter-operator"
            value={rating}
            onChange={handleFilterChange}
            precision={0.5}
            ref={ratingRef}
          />
        </Box>
      );
}

//Filtrar Precio
function ValorPrecioIntroducido(props) {
    const { item, applyValue, focusElementRef } = props;

    const [precio, setPrecio] = useState(
        item.value
          ? Number(item.value) 
          : ''
    );
            
    const precioRef = React.useRef(null);
    React.useImperativeHandle(focusElementRef, () => ({
        focus: () => {
            if( precioRef.current ) {
                precioRef.current.focus();
            }
        },
    }));

    const handleFilterChange = (event, newValue) => {
        const nuevoValor = event.target.value;
        const numero = nuevoValor === '' ? null : Number(nuevoValor);
        setPrecio(nuevoValor);
        applyValue({ ...item, value: numero });
    };
    
      return (
        <Box
        sx={{
            display: 'inline-flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: 48,
            pl: '20px',
        }}
        >
            <TextField
                label="Precio"
                type="number"
                value={precio}
                onChange={handleFilterChange}
                inputRef={precioRef}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        </Box>
      );
}

//Filtrar Fecha
function ValorFechaIntroducido(props) {
    const { item, applyValue, focusElementRef } = props;

    // Estado para la fecha
    const [fecha, setFecha] = useState(
        item.value
          ? new Date(item.value).toISOString().split('T')[0]  // Convierte el Date a "YYYY-MM-DD"
          : ''
      );
      const dateRef = React.useRef(null);

    React.useImperativeHandle(focusElementRef, () => ({
        focus: () => {
            if (dateRef.current) {
                dateRef.current.focus();
            }
        },
    }));

    const handleFilterChange = (event) => {
        const newValue = event.target.value; // Viene en "YYYY-MM-DD"
        setFecha(newValue);
        if (newValue === '') {
          applyValue({ ...item, value: null });
        } else {
          const dateObj = new Date(newValue);
          if (!isNaN(dateObj)) {
            applyValue({ ...item, value: dateObj }); // Se envía el objeto Date
          } else {
            applyValue({ ...item, value: null });
          }
        }
    };
    
    return (
    <Box
        sx={{
            display: 'inline-flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: 48,
            pl: '20px',
        }}
        >
        
        <TextField
            label="Fecha"
            type="date"
            value={fecha}
            onChange={handleFilterChange}
            inputRef={dateRef}
            InputLabelProps={{
                shrink: true,
            }}
        />
    </Box>
    );
}

let baseUrl;
if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
else baseUrl='https://app-formacion.vercel.app';

//Grid tabla componente
const GridTabla = ({ ventas }) => {

    const [abierto, setAbierto] = useState(false);
    const [seleccion, setSeleccion] = useState({producto: null, resenna: null});

    const manejarCierre = () => {
        setAbierto(false);
        setSeleccion(null);
    };
    
    //La información que se mostrará en filas está en venta
    //Columnas
    const columns = useMemo(() => [
        {
            field: "productos",
            headerName: "Producto",
            width: 400,
            renderCell: (params) => {
                const producto = params.row.productos;
                return <ProductoRenderer producto={producto} />; 
            },
            valueGetter: (value, row) => 
                (row.productos.Nombre && row.productos.Descripcion && row.productos.Tematica && row.productos.ImagenPortada && row.productos.FechaSubida) ? row.productos.Nombre : "",
            sortComparator: compararNombre,
            sortable: true,   
            filterable: true, 
        },
        {   
            field: "Fecha",
            headerName: "Fecha de venta",
            width: 150,
            renderCell: (params) => {
                const rawFecha = params.row.Fecha;
                const fecha = new Date(rawFecha);
                if (isNaN(fecha)) return "Fecha inválida";
                return fecha.toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                }).replace(/\//g, "-");
            },
            valueGetter: (value, row) => new Date(row.Fecha),
            sortComparator: compararFecha,
            sortable: true,   
            filterable: true,
            filterOperators: getGridDateOperators()
                .filter((operator) => operator.value !== 'isAnyOf')
                .map((operator) => ({
                    ...operator,
                    InputComponent: operator.InputComponent
                        ? ValorFechaIntroducido
                        : undefined,
                })), 
        },
        {
            field: "cliente",
            headerName: "Cliente",
            width: 300,
            renderCell: (params) => {
                const cliente = params.row.cliente;
                if (!cliente) {
                    return (
                        <div style={{ fontStyle: "italic", color: "#888", textAlign: "center" }}>
                        Cliente eliminado
                        </div>
                    );
                }
                else return <ClienteRenderer cliente={cliente} />;
            },
            valueGetter: (value, row) => (row.cliente ? row.cliente.Usuario : ""),
            sortComparator: compararCliente,
            sortable: true,   
            filterable: true, 
        },
        {
            field: "precio",
            headerName: "Precio",
            width: 100,
            renderCell: (params) => {
                const producto = params.row.productos;
                return <PrecioRenderer producto={producto} />; // Devuelve un valor válido 
            },
            sortable: true,   
            filterable: true, 
            valueGetter: (value, row) => row.productos.Precio,
            sortComparator: compararPrecio,
            filterOperators: getGridNumericOperators()
                .filter((operator) => operator.value !== 'isAnyOf')
                .map((operator) => ({
                    ...operator,
                    InputComponent: operator.InputComponent
                        ? ValorPrecioIntroducido
                        : undefined,
                })), 
        },
        {
            field: "resennas",
            headerName: "Valoración del cliente",
            width: 190,
            renderCell: (params) => {
                const producto = params.row.productos;
                if(!producto.Nombre && !producto.Descripcion && !producto.Tematica && !producto.ImagenPortada && !producto.FechaSubida) return <span style={{ textAlign: "center" }}>-</span>;

                const resennas = params.row.resennas;
                return <ValoracionRenderer resennas={resennas} onClick={() => {
                    if (resennas && resennas.length > 0) {
                        const prod = params.row.productos;
                        setSeleccion({ producto: prod, resenna: resennas});
                        setAbierto(true);
                    } }}
                /> 
            },
            valueGetter: (value, row) => row.resennas && row.resennas.length > 0 ? Number(row.resennas[0].Valoracion) : null,
            sortComparator: compararValoracion,
            sortable: true,   
            filterable: true, 
            filterOperators: getGridNumericOperators()
                .filter((operator) => operator.value !== 'isAnyOf')
                .map((operator) => ({
                    ...operator,
                    label: operator.value === 'isEmpty' ? 'Sin valorar' : operator.label,
                    label: operator.value === 'isNotEmpty' ? 'Con Valoración' : operator.label,
                    InputComponent: operator.InputComponent
                        ? ValorRatingIntroducido
                        : undefined,
                })), 
        },
        {
            field: "devolucion",
            headerName: "Gestionar devolución",
            width: 180,
            renderCell: (params) => {
                const cliente = params.row.cliente;
                if (!cliente) {
                    return (
                        <div style={{ fontStyle: "italic", color: "#888", textAlign: "center" }}>
                            -
                        </div>
                    );
                }

                const producto = params.row.productos;
                if(!producto.Nombre && !producto.Descripcion && !producto.Tematica && !producto.ImagenPortada && !producto.FechaSubida){ 
                    return (
                        <div style={{ fontStyle: "italic", color: "#888", textAlign: "center" }}>—</div>
                    );
                }

                const devueltos = params.row.ProductosDevueltos || [];
                const devueltosArray = devueltos.map((id) => id.toString());
                const estaDevuelto = devueltosArray.includes(
                    producto._id.toString()
                );
                if (estaDevuelto) {
                    return (
                        <span style={{ textAlign: "center", fontStyle: "italic", color: "#fafafa"}}>
                            Producto devuelto
                        </span>
                    );
                }
                return <DevolucionRenderer cliente={cliente} producto={producto} />; 
            },
            sortable: false,   
            filterable: false, 
        },
    ]);

    return (
        <>
            <div className="gridContainer">
                <DataGrid 
                    rows={ventas}
                    columns={columns.map(col => ({
                        ...col,
                        headerAlign: 'center', // Centra el encabezado de la columna
                        align: 'center', // Centra el contenido de la celda
                    }))}
                    pagesize={20}
                    rowsPerPageOptions={[20]}
                    disableSelectionOnClick
                    getRowId={(row) => `${row._id.toString()}_${row.Id_Contenido.toString()}`} //Se genera un identificado único usando _id y Id_Contenido porque al hacer unwind en compras para separar cada contenido el _id se repite
                    sx={{
                        borderColor: 'var(--text-principal)',
                        color: 'var(--text-principal)',  
                        fontSize: "14px",
                        '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#fff',
                        color: 'black',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        borderBottom: '0.25px solid var(--text-principal)'
                        },
                        "& .MuiTablePagination-displayedRows": {
                            color: "#fff", 
                        },
                        "& .MuiDataGrid-footerContainer": {
                            color: 'var(--text-principal)', 
                            fontWeight: "bold",
                        },
                        '& .MuiSvgIcon-root': {
                            color: 'black', // Cambia el color de los íconos en general (como la flecha de ordenación y los tres puntos)
                        },
                        '& .MuiDataGrid-sortIcon': {
                            color: 'black', // Cambia el color de la flecha de ordenación
                        },
                        '& .MuiDataGrid-menuIconButton svg': {
                            color: 'black', // Cambia el color del ícono del menú de la columna (los tres puntos)
                        },
                        // 'Filas por página:' texto
                        "& .MuiTablePagination-selectLabel": {
                            color: 'var(--text-principal)',
                        },
                    
                        // Selector desplegable (100)
                        "& .MuiInputBase-root": {
                            color: "var(--text-principal)",
                        },
                    
                        // Opciones del selector al abrirse
                        "& .MuiMenuItem-root": {
                            color: "black", // texto de los items cuando se despliega el select
                        },
                    
                        // '1–7 de 7'
                        "& .MuiTablePagination-displayedRows": {
                            color: "var(--text-principal)",
                        },
                        '& .MuiDataGrid-row': {
                            borderBottom: '0.25px solid var(--text-principal)', 
                        },
                        // Flechas de navegación
                        "& .MuiSvgIcon-root": {
                            color: "var(--text-principal)",
                        },
                    
                        // Borde del selector 
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#fff",
                        },
                    
                        // Icono del desplegable (flecha abajo del select)
                        "& .MuiSelect-icon": {
                            color: "var(--text-principal)",
                        },
                        // Icono menú cabecera
                        "& .MuiDataGrid-columnHeaderMenuIcon": {
                            color: "black",
                        },
                    }}
                    localeText={{
                        ...esES.components.MuiDataGrid.defaultProps.localeText,
                        rowsPerPage: "Filas por página:",
                    }}
                    
                />
            </div>

            
            <Dialog open={abierto} onClose={manejarCierre} fullWidth maxWidth="md">
                <DialogTitle>
                    {`Reseña de ${seleccion?.producto?.Nombre || ""}`}
                </DialogTitle>
                <DialogContent dividers>
                    {seleccion?.resenna && (
                        <div className="modalVerResennas">
                            <CardResennas resena={seleccion.resenna[0]} style={{ width: '100%' }} />
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={manejarCierre}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const Ventas = () => {

    const [usuario] = useState(() => {
        const usuarioAlmacenado = localStorage.getItem("userLogueado");
        return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
    });
    const [ventas, setVentas] = useState([]);

    const [loading, setLoading] = useState(true);

    //Obtener datos de los productos comprados
    const  fetchProducto = async (idContenido) => {
        //Intentamos buscar en cursos
        try{
            const respCurso = await fetch(`${baseUrl}/api/cursos/${idContenido}`,
                {
                    method: "GET",
                    headers: {"Content-Type": "application/json"}
                }
            );

            if(respCurso.ok){
                const dataCurso = await respCurso.json();
                if(dataCurso && Object.keys(dataCurso).length > 0){
                    return { ...dataCurso, tipo: "curso"};
                }
            }
        } catch(error){
            console.error("Error al obtener el contenido " + error.message);
        }

        //Si no encontramos en cursos, buscamos en clases
        try{
            const respClase = await fetch(`${baseUrl}/api/clases/${idContenido}`,
                {
                    method: "GET",
                    headers: {"Content-Type": "application/json"}
                }
            );

            if(respClase.ok){
                const dataClase = await respClase.json();
                if(dataClase && Object.keys(dataClase).length > 0){
                    return { ...dataClase, tipo: dataClase.Particular ? "claseParticular" : "clase" };
                }
            }
        } catch(error){
            console.error("Error al obtener el contenido " + error.message);
        }

        //Si no se encuentra en ninguna colección, se devuelve null
        return null;
    }

    //Obtener reseña del producto de forma individual
    const fetchResenna = async(idCont, idCliente) => {
            try{               
                const respuesta = await fetch(`${baseUrl}/api/resennas/search/users/${idCliente}/${idCont}`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                });
                
                if(respuesta.ok){
                    const resennaCompra = await respuesta.json();
                    return resennaCompra;
                }
                else return null;
            }catch(error){
                console.error("Error al obtener las resennas de los productos de la compra: "+ error.message);
                return null;
            }
    };
    

    //Función para obtener datos del tutor
    const fetchCliente = async (idCliente) => {
        try{
            const respCliente = await fetch(`${baseUrl}/api/users/${idCliente}`, 
                {
                    method: "GET",
                    headers: {"Content-Type": "application/json" },
                }
            );
            if(respCliente.ok){
                const ClienteData = await respCliente.json();
                return ClienteData;
            }
            else return null
        } catch(error){
            console.error("Error al obtener el cliente: " + error.message);
        }
    }

    useEffect(() => {
        const ventasTutor = async () => {
            setLoading(true);
            try {
                const respuesta = await fetch(`${baseUrl}/api/compras/search/tutor/${usuario._id}`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                });
                const ventasConsultadas = await respuesta.json();
              
                //Añadir Información extra de los productos. Se realizan las consultas al mismo tiempo
                const ventasExtraInfo = await Promise.all(
                    ventasConsultadas.map(async (venta) => {
                        const [productosConInfo, clienteVenta, resennasCliente] = await Promise.all([
                            //Añadimos información del producto que se ha vendido
                            fetchProducto(venta.Id_Contenido),
                            fetchCliente(venta.Id_Usuario),
                            fetchResenna(venta.Id_Contenido, venta.Id_Usuario),     
                        ]);

                        const resennasFiltradas = [resennasCliente].filter((r) => r !== null);
                       
                        //Añadimos información del cliente que ha comprado el producto
                        return { ...venta, productos: productosConInfo, cliente: clienteVenta, resennas: resennasFiltradas};
                    })
                );

                //Ordenar para mostrar en primer lugar las compras más recientes
                ventasExtraInfo.sort((a,b) => new Date(b.Fecha) - new Date(a.Fecha));
                setVentas(ventasExtraInfo);
            } catch(error){
                console.error("Error al obtener los datos de las ventas del tutor: "+ error.message);
            } finally {
                setLoading(false);
            }
        };

        ventasTutor();
    }, [usuario._id])
       
    return(
        <div className="principal">
            <h1>Tus Ventas</h1>   
            <div className="containerVentas">
                {loading ? (
                    <div className="noVentas">
                        <p>Cargando ventas...</p>
                    </div>
                ) : ventas.length === 0 ? (
                    <div className="noVentas"><p>Aún no se ha realizado ninguna venta de su contenido</p></div> 
                ) : (
                    <GridTabla ventas={ventas} /> 
                )}
            </div>
        </div> 
    );
};


export default Ventas;